import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { Text } from '@raptormaps/text';
import { AvatarCircle, UserArea } from './AppHeader.styles';
import { newCustomerRedirect } from '../../utils';

interface HeaderUserProps {
  user: {
    name: string;
    email: string;
  };
}

function deriveInitials(name: string, email: string): string {
  if (name && name.trim()) {
    const words = name.trim().split(/\s+/);
    return words
      .slice(0, 2)
      .map(w => w[0])
      .join('')
      .toUpperCase();
  }
  return email.slice(0, 2).toUpperCase();
}

const HeaderUser: React.FC<HeaderUserProps> = ({ user }) => {
  const { logout } = useAuth0();
  const initials = deriveInitials(user.name, user.email);
  const displayLabel = user.name || user.email;

  return (
    <UserArea>
      <Dropdown alignRight>
        <Dropdown.Toggle
          as="div"
          id="header-user-dropdown"
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <AvatarCircle>{initials}</AvatarCircle>
          <Text
            variant="paragraph_small"
            color="neutral_900"
            style={{ whiteSpace: 'nowrap' }}
          >
            Admin Panel / {displayLabel}
          </Text>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Header>{user.email}</Dropdown.Header>
          <Dropdown.Item
            className="user-menu-item"
            onClick={() => newCustomerRedirect('/account')}
          >
            My Profile
          </Dropdown.Item>
          <Dropdown.Item
            className="user-menu-item"
            onClick={() => logout({ returnTo: window.location.origin })}
          >
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </UserArea>
  );
};

export default HeaderUser;
